const toneClasses = {
  cyan: "border-cyan-500/25 bg-cyan-500/10 text-cyan-300",
  teal: "border-teal-500/25 bg-teal-500/10 text-teal-300",
  emerald: "border-emerald-500/25 bg-emerald-500/10 text-emerald-300",
  rose: "border-rose-500/25 bg-rose-500/10 text-rose-300",
  amber: "border-amber-500/25 bg-amber-500/10 text-amber-300",
};


export const OperationalMetric = ({ icon: Icon, label, value, detail, tone = "cyan" }) => {
  const slug = label.toLowerCase().replace(/\s+/g, "-");
  return (
    <article className="border border-[#1e2b3e] bg-[#0c121d]/90 p-4 rounded-md transition-[border-color,background-color] duration-150 hover:border-[#2b405c] hover:bg-[#101927]" data-testid={`stat-${slug}`}>
      <div className="flex items-start justify-between gap-4"><div><p className="text-xs uppercase text-slate-500">{label}</p><p className="mt-2 font-orbitron text-2xl font-bold text-slate-100" data-testid={`stat-${slug}-value`}>{Number(value || 0).toLocaleString()}</p></div><div className={`flex h-9 w-9 items-center justify-center rounded-md border ${toneClasses[tone]}`}><Icon className="h-4 w-4" /></div></div>
      {detail && <p className="mt-3 border-t border-[#1e2b3e] pt-2 text-xs text-slate-500">{detail}</p>}
    </article>
  );
};